/**
 * Vista: Gestión de Catálogo de Modelos
 * CRUD completo para administrar modelos de tractores
 */

import modeloService from '../services/modelo.service.js';
import lineaComercialService from '../services/lineaComercial.service.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  data: {
    modelos: [],
    lineas: [],
    loading: true,
    showModal: false,
    editingModelo: null,
    filters: {
      search: '',
      marca: '',
      activo: ''
    },
    formData: {
      codigo: '',
      nombre: '',
      linea: '',
      marca: 'LOVOL',
      descripcion: ''
    },
    stats: {}
  },

  async render() {
    return `
      <div class="page-header">
        <h1>Catálogo de Modelos</h1>
        ${permisos.canCreate('modelos') ? `
          <button class="btn btn-primary" id="btnNuevoModelo">
            <span class="icon">➕</span> Nuevo Equipo
          </button>
        ` : ''}
      </div>

      <!-- Estadísticas -->
      <div class="stats-grid" id="statsContainer">
        <div class="loading-spinner"></div>
      </div>

      <!-- Filtros -->
      <div class="filters-card">
        <div class="filters-grid">
          <div class="form-group">
            <label>Buscar</label>
            <input
              type="text"
              id="searchInput"
              placeholder="Código o nombre..."
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label>Marca</label>
            <select id="marcaFilter" class="form-control">
              <option value="">Todas</option>
              <option value="LOVOL">LOVOL</option>
              <option value="MAQMUT">MAQMUT</option>
              <option value="AOSHENG">AOSHENG</option>
              <option value="BEE MACH">BEE MACH</option>
            </select>
          </div>

          <div class="form-group">
            <label>Estado</label>
            <select id="activoFilter" class="form-control">
              <option value="">Todos</option>
              <option value="true">Activos</option>
              <option value="false">Inactivos</option>
            </select>
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" id="btnLimpiarFiltros">
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <!-- Tabla de modelos -->
      <div class="card">
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Código</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Línea</th>
                <th class="tbl-hide-mobile">Marca</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="modelosTableBody">
              <tr>
                <td colspan="7" class="text-center">
                  <div class="loading-spinner"></div>
                  <p>Cargando modelos...</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal para crear/editar -->
      <div id="modeloModal" class="modal" style="display: none;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 id="modalTitle">Nuevo Equipo</h2>
            <button class="modal-close" id="btnCerrarModal">&times;</button>
          </div>

          <form id="modeloForm">
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group">
                  <label>Código *</label>
                  <input
                    type="text"
                    id="codigo"
                    class="form-control"
                    required
                    placeholder="TB504-III"
                    style="text-transform: uppercase;"
                  />
                  <small>Solo letras mayúsculas, números y guiones</small>
                </div>

                <div class="form-group">
                  <label>Marca *</label>
                  <select id="marca" class="form-control" required>
                    <option value="LOVOL">LOVOL</option>
                    <option value="MAQMUT">MAQMUT</option>
                    <option value="AOSHENG">AOSHENG</option>
                    <option value="BEE MACH">BEE MACH</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label>Línea *</label>
                <select id="linea" class="form-control" required>
                  <option value="">Selecciona una línea...</option>
                </select>
              </div>

              <div class="form-group">
                <label>Modelo *</label>
                <input
                  type="text"
                  id="nombre"
                  class="form-control"
                  required
                  placeholder="TB504 III GEN"
                />
              </div>

              <div class="form-group">
                <label>Descripción *</label>
                <textarea
                  id="descripcion"
                  class="form-control"
                  rows="3"
                  required
                  placeholder="Descripción del modelo..."
                ></textarea>
              </div>

            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="btnCancelar">
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary">
                <span class="icon">💾</span> Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('modelos')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.currentView = this;
    await this.cargarLineas();
    await this.cargarEstadisticas();
    await this.cargarModelos();
    this.setupEventListeners();
  },

  async cargarLineas() {
    try {
      const res = await lineaComercialService.listar({ activo: true });
      this.data.lineas = res?.data?.lineas || res?.lineas || [];
    } catch (e) {
      console.warn('No se pudieron cargar las líneas comerciales:', e?.message);
      this.data.lineas = [];
    }
    this._poblarSelectLineas();
  },

  _poblarSelectLineas(seleccionado = '') {
    const sel = document.getElementById('linea');
    if (!sel) return;
    const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const opciones = ['<option value="">Selecciona una línea...</option>']
      .concat(this.data.lineas.map(l =>
        `<option value="${esc(l.codigo)}" ${seleccionado === l.codigo ? 'selected' : ''}>${esc(l.codigo)} — ${esc(l.descripcion)}</option>`
      ));
    sel.innerHTML = opciones.join('');
  },

  setupEventListeners() {
    // Nuevo modelo
    document.getElementById('btnNuevoModelo')?.addEventListener('click', () => {
      this.abrirModal();
    });

    // Cerrar modal
    document.getElementById('btnCerrarModal')?.addEventListener('click', () => {
      this.cerrarModal();
    });

    document.getElementById('btnCancelar')?.addEventListener('click', () => {
      this.cerrarModal();
    });

    // Enviar formulario
    document.getElementById('modeloForm')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.guardarModelo();
    });

    // Filtros
    document.getElementById('searchInput')?.addEventListener('input', (e) => {
      this.data.filters.search = e.target.value;
      this.aplicarFiltros();
    });

    document.getElementById('marcaFilter')?.addEventListener('change', (e) => {
      this.data.filters.marca = e.target.value;
      this.aplicarFiltros();
    });

    document.getElementById('activoFilter')?.addEventListener('change', (e) => {
      this.data.filters.activo = e.target.value;
      this.aplicarFiltros();
    });

    document.getElementById('btnLimpiarFiltros')?.addEventListener('click', () => {
      this.limpiarFiltros();
    });

    // Convertir código a mayúsculas
    document.getElementById('codigo')?.addEventListener('input', (e) => {
      e.target.value = e.target.value.toUpperCase();
    });
  },

  async cargarEstadisticas() {
    try {
      const response = await modeloService.obtenerEstadisticas();
      this.data.stats = response.data.stats;
      this.renderEstadisticas();
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  renderEstadisticas() {
    const stats = this.data.stats;
    const container = document.getElementById('statsContainer');

    if (!container) return;

    container.innerHTML = `
      <div class="stat-card">
        <div class="stat-icon">📊</div>
        <div class="stat-content">
          <div class="stat-value">${stats.total || 0}</div>
          <div class="stat-label">Total Modelos</div>
        </div>
      </div>

      <div class="stat-card stat-success">
        <div class="stat-icon">✅</div>
        <div class="stat-content">
          <div class="stat-value">${stats.activos || 0}</div>
          <div class="stat-label">Activos</div>
        </div>
      </div>

      <div class="stat-card stat-warning">
        <div class="stat-icon">⏸️</div>
        <div class="stat-content">
          <div class="stat-value">${stats.inactivos || 0}</div>
          <div class="stat-label">Inactivos</div>
        </div>
      </div>

      <div class="stat-card stat-info">
        <div class="stat-icon">🚜</div>
        <div class="stat-content">
          <div class="stat-value">${stats.lovol || 0}</div>
          <div class="stat-label">LOVOL</div>
        </div>
      </div>
    `;
  },

  async cargarModelos() {
    this.data.loading = true;
    const tbody = document.getElementById('modelosTableBody');

    try {
      const response = await modeloService.listar(this.data.filters);
      this.data.modelos = response.data.modelos || [];
      this.renderTabla();
    } catch (error) {
      console.error('Error al cargar modelos:', error);
      if (tbody) {
        tbody.innerHTML = `
          <tr>
            <td colspan="9" class="text-center error-message">
              Error al cargar modelos: ${error.message}
            </td>
          </tr>
        `;
      }
    } finally {
      this.data.loading = false;
    }
  },

  renderTabla() {
    const tbody = document.getElementById('modelosTableBody');
    if (!tbody) return;

    if (!this.data.modelos || this.data.modelos.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="9" class="text-center">
            No se encontraron modelos
          </td>
        </tr>
      `;
      return;
    }

    tbody.innerHTML = this.data.modelos.map(modelo => {
      const marcaBadge = `<span class="badge badge-${this.getBadgeMarca(modelo.marca)}">${modelo.marca}</span>`;
      const estadoBadge = `<span class="badge ${modelo.activo ? 'badge-success' : 'badge-secondary'}">${modelo.activo ? 'Activo' : 'Inactivo'}</span>`;
      const accionesHtml = `
        ${permisos.canEdit('modelos') ? `<button class="btn-icon btn-edit" onclick="window.currentView.editarModelo(${modelo.id})" title="Editar">✏️</button>` : ''}
        ${permisos.can('modelos', 'cambiar_estado') ? `<button class="btn-icon ${modelo.activo ? 'btn-warning' : 'btn-success'}" onclick="window.currentView.toggleActivo(${modelo.id})" title="${modelo.activo ? 'Desactivar' : 'Activar'}">${modelo.activo ? '⏸️' : '▶️'}</button>` : ''}
        ${permisos.canDelete('modelos') ? `<button class="btn-icon btn-danger" onclick="window.currentView.eliminarModelo(${modelo.id})" title="Eliminar">🗑️</button>` : ''}
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.currentView.toggleRow(${modelo.id})">&#9654;</button></td>
        <td><strong>${modelo.codigo}</strong></td>
        <td class="tbl-hide-mobile">${modelo.nombre}</td>
        <td class="tbl-hide-mobile">${modelo.linea || '-'}</td>
        <td class="tbl-hide-mobile">${marcaBadge}</td>
        <td class="tbl-hide-mobile">${estadoBadge}</td>
        <td class="tbl-hide-mobile">
          <div class="action-buttons">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-mod-${modelo.id}">
        <td colspan="7" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Modelo</dt><dd>${modelo.nombre}</dd>
            <dt>Línea</dt><dd>${modelo.linea || '-'}</dd>
            <dt>Marca</dt><dd>${marcaBadge}</dd>
            <dt>Estado</dt><dd>${estadoBadge}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  getBadgeMarca(marca) {
    const badges = {
      'LOVOL': 'primary',
      'MAQMUT': 'info',
      'AOSHENG': 'success',
      'BEE MACH': 'secondary'
    };
    return badges[marca] || 'secondary';
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-mod-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  abrirModal(modelo = null) {
    this.data.editingModelo = modelo;
    const modal = document.getElementById('modeloModal');
    const title = document.getElementById('modalTitle');

    if (modelo) {
      title.textContent = 'Editar Equipo';
      document.getElementById('codigo').value = modelo.codigo;
      document.getElementById('nombre').value = modelo.nombre;
      document.getElementById('linea').value = modelo.linea || '';
      document.getElementById('marca').value = modelo.marca;
      document.getElementById('descripcion').value = modelo.descripcion || '';
    } else {
      title.textContent = 'Nuevo Equipo';
      document.getElementById('modeloForm').reset();
      document.getElementById('marca').value = 'LOVOL';
    }

    modal.style.display = 'flex';
  },

  cerrarModal() {
    const modal = document.getElementById('modeloModal');
    modal.style.display = 'none';
    document.getElementById('modeloForm').reset();
    this.data.editingModelo = null;
  },

  async guardarModelo() {
    const lineaValor = document.getElementById('linea').value.trim();
    if (!lineaValor) {
      this.showNotification('La línea es requerida', 'warning');
      return;
    }
    const formData = {
      codigo: document.getElementById('codigo').value.trim().toUpperCase(),
      nombre: document.getElementById('nombre').value.trim(),
      linea: lineaValor,
      marca: document.getElementById('marca').value,
      descripcion: document.getElementById('descripcion').value.trim() || null
    };

    try {
      if (this.data.editingModelo) {
        await modeloService.actualizar(this.data.editingModelo.id, formData);
        this.showNotification('Equipo actualizado exitosamente', 'success');
      } else {
        await modeloService.crear(formData);
        this.showNotification('Equipo creado exitosamente', 'success');
      }

      this.cerrarModal();
      await this.cargarModelos();
      await this.cargarEstadisticas();
    } catch (error) {
      console.error('Error al guardar modelo:', error);
      this.showNotification(error.message || 'Error al guardar equipo', 'error');
    }
  },

  async editarModelo(id) {
    try {
      const response = await modeloService.obtenerPorId(id);
      this.abrirModal(response.data.modelo);
    } catch (error) {
      console.error('Error al cargar modelo:', error);
      this.showNotification('Error al cargar equipo', 'error');
    }
  },

  async toggleActivo(id) {
    const modelo = (this.data.modelos || []).find(m => m.id === id);
    const nombre = modelo?.nombre || 'este equipo';
    const accion = modelo?.activo ? 'desactivar' : 'activar';
    modal.confirm(
      'Cambiar estado del equipo',
      `¿Está seguro de ${accion} a <strong>${nombre}</strong>?`,
      async () => {
        try {
          await modeloService.toggleActivo(id);
          this.showNotification('Estado actualizado', 'success');
          await this.cargarModelos();
          await this.cargarEstadisticas();
        } catch (error) {
          console.error('Error:', error);
          this.showNotification('Error al cambiar estado', 'error');
        }
      }
    );
  },

  async eliminarModelo(id) {
    const modelo = (this.data.modelos || []).find(m => m.id === id);
    const nombre = modelo?.nombre || 'este equipo';
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar a <strong>${nombre}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await modeloService.eliminar(id);
          this.showNotification('Equipo eliminado exitosamente', 'success');
          await this.cargarModelos();
          await this.cargarEstadisticas();
        } catch (error) {
          console.error('Error:', error);
          this.showNotification(error.message || 'Error al eliminar equipo', 'error');
        }
      }
    );
  },

  aplicarFiltros() {
    this.cargarModelos();
  },

  limpiarFiltros() {
    this.data.filters = {
      search: '',
      marca: '',
      activo: ''
    };

    document.getElementById('searchInput').value = '';
    document.getElementById('marcaFilter').value = '';
    document.getElementById('activoFilter').value = '';

    this.cargarModelos();
  },

  showNotification(message, type = 'info') {
    // Implementar sistema de notificaciones
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.remove();
    }, 3000);
  }
};
